export enum DocumentTypesEnum {
    Passport = 1,
    UtilityBill = 2,
    DrivingLicence = 3,
    Payslip = 4,
    S302 = 5,
    BankStatement = 6,
    CreditCardStatement = 7,
    LoanHirePurchaseAgreement = 8,
    MemorandumOfSale = 9,
    MortgageRedemptionFigure = 10,
    LandlordReferenceLetter = 11,
    CopyOfTenancyAgreement = 12,
    RentBoardLetterFromParents = 13,
    DepositGiftedLetter = 14,
    ProofOfSavings = 15,
    CreditReport = 16,
    ArmedForcesProof = 17,
    Other = 20,
    ApprovedApplicantFormPDF = 30,
}
